//
// Validation rules
// TODO: それぞれの型ドメインの評価チェックを記述する
//
export function required (name) {
  return function (v) {
    return !!v || `${name}を入力してください`
  }
}

export function email (v) {
  if (!v) {
    return true
  }
  if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v))) {
    return 'メールアドレスの形式が完全ではありません'
  }
  return true
}

export function date (v) {
  if (!v) {
    return true
  }
  do {
    const match = v.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) {
      break
    }
    const y = match[1] - 0
    const m = match[2] - 1
    const d = match[3] - 0
    const date = new Date(y, m, d)
    if (date.getFullYear() !== y || date.getMonth() !== m || date.getDate() !== d) {
      break
    }

    return true
  } while (false)

  return '日付が正しくありません'
}

export function loginID (v) {
  return true
}

export function password (v) {
  if (!v) {
    return true
  }
  if (!(/^[0-9A-Za-z!?#$%()+\-*/=@;:,._<>[\]{}]+$/.test(v))) {
    return '利用できない文字が含まれています'
  }
  if (v.length < 6 || v.length > 64) {
    return '6〜64文字を設定できます'
  }
  let cnt = 0
  if ((/[A-Z]/.test(v))) {
    cnt = cnt + 1
  }
  if ((/[a-z]/.test(v))) {
    cnt = cnt + 1
  }
  if ((/[0-9]/.test(v))) {
    cnt = cnt + 1
  }
  if ((/[!?#$%()+\-*/=@;:,._<>[\]{}]/.test(v))) {
    cnt = cnt + 1
  }
  if (cnt < 3) {
    return '英大文字、小文字、数字、記号の内、3種類以上の文字を入れてください'
  }
  return true
}

export function verifyCode (v) {
  if (!v) {
    return true
  }
  if (!(/^[0-9]+$/.test(v))) {
    return '半角数字が入力できます'
  }
  if (v.length !== 6) {
    return '6文字入力してください'
  }
  return true
}

export function username (v) {
  if (!v) {
    return true
  }
  if (v.length > 40) {
    return '40文字まで入力できます'
  }
  return true
}

export function userkana (v) {
  if (!v) {
    return true
  }
  if (v.length > 40) {
    return '40文字まで入力できます'
  }
  return true
}

export function gender (v) {
  return true
}

export function birthday (v) {
  return true
}

export function postal (v) {
  return true
}

export function address (v) {
  return true
}

export function phone (v) {
  if (!v) {
    return true
  }
  if (!(/^[0-9\-*#]+$/.test(v))) {
    return '半角数字の他 - # * が入力できます'
  }
  if (v.length > 30) {
    return '30文字まで入力できます'
  }
  return true
}

export function peoples (seat) {
  return function (v) {
    if (!v) {
      return true
    }
    if (!(/^[0-9]+$/.test(v))) {
      return '半角数字が入力できます'
    }
    v -= 0
    if (v === 0) {
      return '利用人数を入力してください'
    }
    if (v > seat) {
      return `${seat} 名までご乗車頂けます`
    }
    return true
  }
}

export function couponCode (v) {
  if (!v) {
    return true
  }
  if (!(/^[0-9A-Za-z]+$/.test(v))) {
    return '半角英数字が入力できます'
  }
  return true
}

export function licenseNo (v) {
  if (!v) {
    return true
  }
  if (!(/^[0-9]{12}$/.test(v))) {
    return '半角数字12桁が入力できます'
  }
  return true
}

export function licenseAcquire (v) {
  return true
}

export function licenseExpire (v) {
  return true
}

export function licenseTypes (v) {
  const base = v.slice(0, 4)
  if (base.indexOf('1') >= 0) {
    return true
  }
  return '普通自動車を運転できる免許を選択してください'
}

export function cardExpire (v) {
  return true
}

export function cardCvc (v) {
  return true
}
